import { fallbackError, getStatusMessage } from "./errors";

// function parseErrorMessage(body: { code: number; message?: string }) {
//   // TODO:
//   // Do not do this when the server starts to send
//   // readable error messages.
//   let [message] = (body.message || '').split(';');
//   return message || fallbackError.message;
// }

export interface NormalizedError {
  code: number | string;
  message?: string;
  detail: string;
  instance: string;
  status: number | null;
  title: string;
  type: string;
}

interface ICollectedData {
  status?: number | string;
  message?: number | string;
}

function assignTruthyValues(obj1: any, obj2: any) {
  for (let key in obj2) {
    if (obj2[key] != null) {
      obj1[key] = obj2[key];
    }
  }
  return obj1;
}

export function normalizeError(requestError: any): NormalizedError {
  /**
   * Possible errors that the server can send are:
   *
   * { errorCode: number, message: string } |
   * { error: string, error_description: string }
   *
   * These objects are found in `requestError.response.body`.
   *
   * If the server fails to send a message (e.g. 5xx errors),
   * then we expect the `requestError` to be at least
   * { status: number, message?: string }
   *
   * Another possibility is going offline. In that case `status` is undefined,
   * and we only have a `message` set by the browser:
   * { message: string }
   */

  const { code: fallbackCode, message: fallbackMessage } = fallbackError;
  const error: NormalizedError = {
    code: fallbackCode,
    status: null,
    message: requestError.status ? getStatusMessage(requestError.status) : fallbackMessage,
    detail: requestError.detail,
    instance: requestError.instance,
    title: requestError.title,
    type: requestError.type,
  };

  const collectedData: ICollectedData = {};

  if (requestError.response && requestError.response.body) {
    return requestError.response.body;
  } else if (requestError.status != null) {
    collectedData.status = requestError.status;
  } else if (requestError.message) {
    // offline errors
    collectedData.message = requestError.message;
  } else if (requestError.error_description) {
    collectedData.message = requestError.error_description;
  }

  return assignTruthyValues(error, collectedData);
}

export function errorHandler<T>(error: Error): T {
  throw normalizeError(error);
}
